module.exports = __webpack_public_path__ + "images/emoji/clock3.fe01ca4b86c3abf69b43.png";